export const iconPickerTranslations = {
    en: {
        iconPicker: {
            label: 'Icon',
            selectIcon: 'Select an icon',
            searchPlaceholder: 'Search icons...',
            categories: {
                food: 'Food',
                drinks: 'Drinks',
                desserts: 'Desserts',
                other: 'Other'
            },
            icons: {
                rice_bowl: 'Rice Bowl',
                bread: 'Bread',
                noodles: 'Noodles',
                tacos: 'Tacos',
                fruit_bowl: 'Fruit Bowl',
                cupcake: 'Cupcake',
                meat: 'Meat',
                french_fries: 'French Fries',
                chicken: 'Chicken',
                sushi: 'Sushi',
                hot_meal: 'Hot Meal',
                sandwich: 'Sandwich',
                salt: 'Salt',
                food_chain: 'Food Chain',
                coffee: 'Coffee',
                tea: 'Tea',
                soda: 'Soda',
                water: 'Water',
                milk: 'Milk',
                wine: 'Wine',
                beer: 'Beer',
                shot: 'Shot',
                ice_cream: 'Ice Cream',
                cake: 'Cake',
                cookie: 'Cookie',
                chocolate: 'Chocolate',
                honey: 'Honey',
                restaurant: 'Restaurant',
                menu: 'Menu',
                food_bank: 'Food Bank',
                food_beverage: 'Food Beverage',
                utensils: 'Utensils',
                service_bell: 'Service Bell',
                hamburger: 'Hamburger',
                pizza: 'Pizza'
            }
        }
    },
    ar: {
        iconPicker: {
            label: 'أيقونة',
            selectIcon: 'اختر أيقونة',
            searchPlaceholder: 'البحث عن الأيقونات...',
            categories: {
                food: 'طعام',
                drinks: 'مشروبات',
                desserts: 'حلويات',
                other: 'أخرى'
            },
            icons: {
                rice_bowl: 'وعاء أرز',
                bread: 'خبز',
                noodles: 'نودلز',
                tacos: 'تاكو',
                fruit_bowl: 'وعاء فواكه',
                cupcake: 'كب كيك',
                meat: 'لحم',
                french_fries: 'بطاطس مقلية',
                chicken: 'دجاج',
                sushi: 'سوشي',
                hot_meal: 'وجبة ساخنة',
                sandwich: 'ساندويتش',
                salt: 'ملح',
                food_chain: 'سلسلة غذائية',
                coffee: 'قهوة',
                tea: 'شاي',
                soda: 'مشروب غازي',
                water: 'ماء',
                milk: 'حليب',
                wine: 'نبيذ',
                beer: 'بيرة',
                shot: 'جرعة',
                ice_cream: 'آيس كريم',
                cake: 'كيك',
                cookie: 'كوكيز',
                chocolate: 'شوكولاتة',
                honey: 'عسل',
                restaurant: 'مطعم',
                menu: 'قائمة',
                food_bank: 'بنك الطعام',
                food_beverage: 'طعام ومشروبات',
                utensils: 'أدوات المائدة',
                service_bell: 'جرس الخدمة',
                hamburger: 'برجر',
                pizza: 'بيتزا'
            }
        }
    }
};
